import src from "IMAGE";
export default { src, width: 464, height: 128, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42m3IMQ4AEBAEwF0kV4iN6BDeo/D/96gkClMO8JDarGNt0nn8RLOSkzrJcO8APowBnjwn6ggAAAAASUVORK5CYII="};
